import { useTranslation } from 'react-i18next';

import { useModals } from '@any-ui-react/modals';

import { RichMenuSelectorContent } from '../rich-menu-selector-content';
import { RichMenuItem } from '../types';

interface UseOpenLineRichMenuSelectorProps {
  storeId: string;
  onConfirm: (richMenu: RichMenuItem) => void;
}
const DIALOG_ID = 'workflow-rich-menu-selector';

export const useLineRichMenuSelectorDialog = ({
  storeId,
  onConfirm,
}: UseOpenLineRichMenuSelectorProps) => {
  const { openModal, closeModal } = useModals();
  const { t } = useTranslation('crm');

  const openLineRichMenuSelectorDialog = ({ richMenuId }: { richMenuId?: string }) =>
    openModal({
      modalId: DIALOG_ID,
      title: t('crm.richMenuSelector.dialog.selectRichMenu.title'),
      children: (
        <RichMenuSelectorContent
          richMenuId={richMenuId}
          storeId={storeId}
          onConfirm={onConfirm}
          onClose={() => closeModal(DIALOG_ID)}
        />
      ),
    });

  return {
    openLineRichMenuSelectorDialog,
  };
};
